import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import hearingChart from '../../static/images/hearingChart.jpg';
import xIcon from '../../static/images/X.png';
import oIcon from '../../static/images/O.png';

import DetectionSendResultModal from './DetectionSendResultModal.js';
import DetectionRuleModal from './DetectionRuleModal.js';
import Helpers from '../../helpers';

var POINT_OFFSET = 8;
var MAP_VERTICAL_OFFSET = 133;
var MAP_HORIZONTAL_OFFSET = 146;
var BLOCK_VERTICAL_OFFSET = 40;
var BLOCK_HORIZONTAL_OFFSET = 29;
var RADIUS = 8;

const styles = {
  wrap: {
    maxWidth: 1000,
    height: '100%',
    display: 'flex',
    margin: '0 auto',
    minHeight: 'calc(100vh - 100px)',
    '@media (max-width: 767px)': {
      display: 'block',
    }
  },
  wrap_TV:{
    height: '-webkit-fill-available',
    display: 'block',
    margin: '0px',
    overflow: 'hidden'
  },
  canvasWrap: {
    width: 387,
    height: 499,
    backgroundImage: `url(${hearingChart})`,
    backgroundSize: '387px 501px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'relative',
    margin: '0 auto',
    '@media (max-width: 767px)': {
      width: 300,
      height: 400,
      backgroundSize: '300px 400px',
    }
  },
  canvasWrap_TV: {
    width: 1000,
    height: 1200,
    backgroundImage: `url(${hearingChart})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'relative',
    margin: '5% auto',
  },
  leftWrap: {
    padding: '70px 0 0px 0',
    width: 560,
    backgroundColor: '#FFF8D1',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      width: '100%',
      padding: '20px 0',
    }
  },
  leftWrap_TV: {
    padding: '1px 0px',
    width: '100%',
    backgroundColor: '#FFF8D1',
    textAlign: 'center',
  },
  rightWrap: {
    margin: '70px 0 0 0',
    padding: '10px 20px',
    flex: 1,
    '@media (max-width: 767px)': {
      margin: '10px 0 0 0',
    }
  },
  rightWrap_TV: {
    margin: '3% 0px 0px',
    textAlign: 'center',
    flex: 1,
  },
  title: {
    fontSize: 18,
    display: 'block',
    marginBottom: 20
  },
  title_TV: {
    fontSize: 35,
    display: 'block',
    marginBottom: 20,
  },
  emphasis: {
    fontSize: 48,
    color: '#4A4A4A',
    display: 'block',
    margin: '10px 0px',
    lineHeight: '49px',
    '@media (max-width: 767px)': {
      fontSize: 38,
    }
  },
  emphasis_TV:{
    fontSize: 56,
    color: '#4A4A4A',
    margin: '10px 0px',
    lineHeight: '49px',
    padding: '0px 0px 0px 20px',
  },
  blueColor: {
    color: '#004D9F',
    fontSize: 48,
    display: 'inline-block',
    margin: '0px 20px',
    lineHeight: '49px',
    '@media (max-width: 767px)': {
      fontSize: 38,
    },
  },
  textWrap: {
    margin: '40px 0 20px 0',
  },
  text: {
    display: 'block',
    lineHeight: 1.5,
    color: '#4A4A4A',
    fontSize: 15
  },
  text_TV: {
    display: 'block',
    lineHeight: 1.5,
    color: '#4A4A4A',
    fontSize: 35,
  },
  button: {
    width: 260,
    outline: 'none',
    border: 0,
    backgroundColor: '#FED312',
    lineHeight: '42px',
    textAlign: 'center',
    color: 'white',
    letterSpacing: 3,
    fontSize: 18,
    borderRadius: 3,
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      width: '100%',
    }
  },
  canvas: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  icon_TV: {
    width: 40,
    height: 40,
  },
  emphasisWrap_TV: {
    width: '40%',
    display: 'inline-block',
  }
};

class DetectionTestResult extends Component {
  
  componentDidMount() {

    if (Helpers.Session.isViaTV()) {
      POINT_OFFSET = 20;
      MAP_VERTICAL_OFFSET = 350;
      MAP_HORIZONTAL_OFFSET = 360;
      BLOCK_VERTICAL_OFFSET = 100;
      BLOCK_HORIZONTAL_OFFSET = 60;
      RADIUS = 20;
    }

    this.canvas = document.getElementById('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.drawResult();
  }

  drawResult() {
    const {
      leftResult,
      rightResult,
    } = this.props;
    this.drawLeft(leftResult);
    this.drawRight(rightResult);
  }

  drawLeft(leftResult) {
    // Make points
    const windowWidth = document.body.clientWidth;
    let rateWidth = 1;
    let rateHeight = 1;
    if (windowWidth <= 767) {
      rateWidth = 300 / 387;
      rateHeight = 400 / 499;
    }
    const leftPoints = leftResult.map((value, idx) => {
      let obj = null;
      switch (idx) {
        case 0: // 4000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET * 3) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 1: // 2000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET * 2) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 2: // 500Hz
          obj = {
            x: MAP_VERTICAL_OFFSET * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 3: // 1000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        default:
      }
      return obj;
    });

    var leftColor = '#2E3192';

    // Draw connectors
    this.ctx.beginPath();
    this.ctx.lineWidth = (Helpers.Session.isViaTV())? 5 : 1;
    this.ctx.strokeStyle = leftColor;
    this.ctx.fillStyle = 'rgba(92, 189, 231, 0.3)';

    this.ctx.lineTo(leftPoints[2].x, leftPoints[2].y);
    this.ctx.lineTo(leftPoints[3].x, leftPoints[3].y);
    this.ctx.lineTo(leftPoints[1].x, leftPoints[1].y);
    this.ctx.lineTo(leftPoints[0].x, leftPoints[0].y);

    this.ctx.stroke();

    // Draw points
    this.ctx.strokeStyle = leftColor;
    this.ctx.lineWidth = (Helpers.Session.isViaTV())? 20 : 3;

    leftPoints.forEach((point) => {
      this.ctx.beginPath();
      this.ctx.moveTo(point.x - POINT_OFFSET, point.y - POINT_OFFSET);
      this.ctx.lineTo(point.x + POINT_OFFSET, point.y + POINT_OFFSET);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(point.x + POINT_OFFSET, point.y - POINT_OFFSET);
      this.ctx.lineTo(point.x - POINT_OFFSET, point.y + POINT_OFFSET);
      this.ctx.stroke();
    });
  }

  drawRight(rightResult) {
    const windowWidth = document.body.clientWidth;
    let rateWidth = 1;
    let rateHeight = 1;
    if (windowWidth <= 767) {
      rateWidth = 300 / 387;
      rateHeight = 400 / 499;
    }
    // Make points
    const rightPoints = rightResult.map((value, idx) => {
      let obj = null;
      switch (idx) {
        case 0: // 4000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET * 3) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 1: // 2000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET * 2) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 2: // 500Hz
          obj = {
            x: MAP_VERTICAL_OFFSET * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        case 3: // 1000Hz
          obj = {
            x: (MAP_VERTICAL_OFFSET + BLOCK_VERTICAL_OFFSET) * rateWidth,
            y: (MAP_HORIZONTAL_OFFSET + (value - 20) / 10 * BLOCK_HORIZONTAL_OFFSET) * rateHeight,
          };
          break;
        default:
      }
      return obj;
    });

    var rightColor = '#E50012'

    // Draw connectors
    this.ctx.beginPath();
    this.ctx.lineWidth = (Helpers.Session.isViaTV())? 5 : 1;
    this.ctx.strokeStyle = rightColor;
    this.ctx.fillStyle = 'rgba(255, 0, 6, 0.3)';

    this.ctx.lineTo(rightPoints[2].x, rightPoints[2].y);
    this.ctx.lineTo(rightPoints[3].x, rightPoints[3].y);
    this.ctx.lineTo(rightPoints[1].x, rightPoints[1].y);
    this.ctx.lineTo(rightPoints[0].x, rightPoints[0].y);

    this.ctx.stroke();

    // Draw points
    this.ctx.strokeStyle = rightColor;
    this.ctx.lineWidth = (Helpers.Session.isViaTV())? 20 : 3;

    rightPoints.forEach((point) => {
      this.ctx.save();
      this.ctx.beginPath();

      this.ctx.strokeStyle = '#9B9B9B';
      this.ctx.arc(point.x, point.y, RADIUS, 0, Math.PI * 2, true);
      this.ctx.clip();

      this.ctx.strokeStyle = rightColor;
      this.ctx.arc(point.x, point.y, RADIUS, 0, Math.PI * 2, false);
      this.ctx.fillStyle = rightColor;
      this.ctx.fill();
      this.ctx.stroke();
      this.ctx.restore();
    });
  }

  render() {
    const {
      leftResult,
      rightResult,
      openSendForm,
    } = this.props;

    if (!leftResult.length || !rightResult.length) {
      return null;
    }

    const maxLeft = Math.max.apply(null, leftResult);
    const maxRight = Math.max.apply(null, rightResult);
    const windowWidth = document.body.clientWidth;

    let width = 387;
    let height = 501;
    if (windowWidth < 767) {
      width = 300;
      height = 400;
    }

    if (Helpers.Session.isViaTV()) {
      width = 1100;
      height = 900;
    }

    var wrap = styles.wrap;
    var canvasWrap =styles.canvasWrap;
    var leftWrap = styles.leftWrap;
    var rightWrap = styles.rightWrap;
    var title = styles.title;
    var emphasis = styles.emphasis;
    var text = styles.text;

    if (Helpers.Session.isViaTV()) {
      wrap = styles.wrap_TV;
      canvasWrap = styles.canvasWrap_TV;
      leftWrap = styles.leftWrap_TV;
      rightWrap = styles.rightWrap_TV;
      title = styles.title_TV;
      emphasis = styles.emphasis_TV;
      text = styles.text_TV;
    }

    var sendButton = <button type="button" style={styles.button} onClick={() => openSendForm()}>發送檢測結果</button>;

    if (Helpers.Session.isViaTV()) {
      sendButton = null;
    }

    var emphasisLeft = <span style={emphasis}>左耳<span style={[styles.blueColor]}>{maxLeft}</span>分貝</span>;

    var emphasisRight = <span style={emphasis}>右耳<span style={[styles.blueColor]}>{maxRight}</span>分貝</span>;

    var storeLocations = <div style={styles.textWrap}>
        <p>
          <span style={text}>謝謝您參加科林助聽器聽力篩檢活動，</span>
          <span style={text}>依據您本次檢測結果，我們建議您至全台科林門市做更詳細的檢查！</span>
          <span style={text}>查詢全台門市：</span>
          <a 
            target="_blank" 
            href="https://www.ear.com.tw/clinico/tw/Location" 
            style={text}>https://www.ear.com.tw/clinico/tw/Location</a>
        </p>
      </div>


    if (Helpers.Session.isViaTV()) {
      emphasisLeft = 
        <div style={styles.emphasisWrap_TV}>
          <img src={xIcon} style={styles.icon_TV} />
          <span style={emphasis}>左耳<span style={[styles.blueColor]}>{maxLeft}</span>分貝</span>
        </div>;

      emphasisRight =
        <div style={styles.emphasisWrap_TV}>
          <img src={oIcon} style={styles.icon_TV} />
          <span style={emphasis}>右耳<span style={[styles.blueColor]}>{maxRight}</span>分貝</span>
        </div>;

      storeLocations = <div style={styles.textWrap}>
        <p>
          <span style={text}>謝謝您參加科林助聽器聽力篩檢活動，</span>
        </p>
      </div>
    }

    return (
      <div style={wrap}>
        <div style={leftWrap}>
          <div style={canvasWrap}>
            <canvas
              id="canvas"
              style={styles.canvas}
              width={width}
              height={height}>
            </canvas>
          </div>
        </div>
        <div style={rightWrap}>
          <div style={styles.result}>
            <span style={title}>本次測驗結果：</span>
            {emphasisLeft}
            {emphasisRight}
          </div>
          {storeLocations}
          {sendButton}
        </div>
        <DetectionSendResultModal left={maxLeft} right={maxRight} />
        <DetectionRuleModal />
      </div>
    );
  }
}

DetectionTestResult.propTypes = {
  leftResult: T.array,
  rightResult: T.array,
  openSendForm: T.func,
};

export default connect(
  state => ({
    rightResult: state.Detection.rightResult,
    leftResult: state.Detection.leftResult,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionTestResult));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionTestResult.js